import {RealDeviceForm} from "pages/admin/devices/form/RealDeviceForm"
import {RealDevice} from "dto/realdevice/devices"
import {DeviceInput} from "pages/admin/devices/form/DeviceInput"
import {AxiosError} from "axios"
import {useUpdateRealDeviceMutation} from "hooks/queries/real-device.query"
import {useQuery, useQueryClient} from "react-query"

interface UpdateDeviceProps {
    show: boolean
    close: () => void
    device: RealDevice
}

export const UpdateDevice = ({show, close, device}: UpdateDeviceProps) => {
    const queryClient = useQueryClient()
    const updateRealDevice = useUpdateRealDeviceMutation()
    const onSubmit = async (value: DeviceInput) => {
        const device: RealDevice = {
            id: value.id,
            name: value.name,
            serialNumber: value.serialNumber,
            ignoreExternalEmission: value.ignoreExternalEmission,
            mobile: {phoneNumber: value.mobile},
            address: {
                address: value.address,
                subAddress: value.subAddress
            },
            etc: value.etc,
            communicationDevice: {
                eui: value.deviceEui.toLowerCase(),
            },
            removeImage: value.removeImage,
            imageFiles: value.remoteImgFiles,
            categoryId: value.categoryId,
            protector: {
                name: value.protectorName || '',
                mobile: value.protectorMobile || ''
            },
            secondaryProtector: {
                name: value.secondaryProtectorName || '',
                mobile: value.secondaryProtectorMobile|| ''
            },
            installationDate: value.installationDate
        }

        const param = {
            device,
            file: value.imgFile,
            imgFiles: value.localImgFiles
        }
        updateRealDevice.mutate(param, {
            onSuccess: (data, variables, context) => {
                console.log("success value : ", data, variables, context)
                queryClient.invalidateQueries(["real-device/list"])
                close()
            },
            onError: (err, variables, context) => {
                const error = (err as AxiosError)
                console.log("error value : ", error, variables, context)
            },
        })
    }
    return (
        <RealDeviceForm show={show} close={close} device={device} onSubmit={onSubmit}/>
    )
}